import './bootstrap';
import Splide from "@splidejs/splide";
import * as noUiSlider from "nouislider/dist/nouislider.js";

window.onload = function() {
  if (document.querySelector('#showcase-samples')) {
    new Splide("#showcase-samples", {
      arrows: false,
    }).mount();
  }

  const toggleMenu = () => {
    document.querySelector("#m-menu-overlay").classList.toggle("hidden");
    document
        .querySelector("#m-menu-drawer")
        .classList.toggle("translate-x-full");
  }

  document.querySelector("#btn-m-menu").addEventListener('click', () => {
    toggleMenu();
  });

  document.querySelector("#btn-menu-close").addEventListener('click', () => {
    toggleMenu();
  });

  document.querySelector("#m-menu-overlay").addEventListener('click', () => {
    toggleMenu();
  });

  document.querySelector("#form-products") &&
    document
      .querySelector("#form-products")
      .addEventListener("click", function (e) {
        if (e.target && e.target.hasAttribute("data-fn")) {
          document.querySelector(
            "#form-products input[name=" +
              e.target.getAttribute("data-fn") +
              "]"
          ).value = e.target.getAttribute("data-v");

          document.querySelector("#form-products").submit();
        }
      });

  if (document.querySelector("#active-filters")) {
    document
      .querySelector("#active-filters")
      .addEventListener("click", function (e) {
        if (e.target && e.target.nodeName.toLowerCase() === "button") {
          document.querySelector(
            "#form-products input[name=" +
              e.target.getAttribute("data-fn") +
              "]"
          ).value = "";

          document.querySelector("#form-products").submit();
        }
      });
  }

  document.querySelector("#btn-whatsapp") &&
    document
      .querySelector("#btn-whatsapp")
      .addEventListener("click", function () {
        alert($(this).getAttribute("data-value"));
      });

  document.querySelector("#form-email") &&
    document
      .querySelector("#form-email")
      .addEventListener("submit", function (e) {
        e.preventDefault();

        const submitButton = document.querySelector(
          "#form-email button[type=submit]"
        );

        submitButton.setAttribute('disabled', true);
        submitButton.classList.add("pointer-events-none", "opacity-50");

        const that = this;

        grecaptcha.ready(function () {
          grecaptcha
            .execute("6Le5YSEeAAAAANMRMAk_BU2qRoPuUTGJXVzcCVst", {
              action: "submit",
            })
            .then(function (token) {
              const input = document.createElement("input");
              input.setAttribute("type", "hidden");
              input.setAttribute("name", "g-recaptcha-response");
              input.value = token;

              that.append(input);

              that.submit();
            });
        });
      });

  if (document.querySelector("#product-slider")) {
    new Splide("#product-slider", {
      arrows: false,
    }).mount();
  }

  const priceSliders = document.querySelectorAll(".price-slider");
  if (priceSliders.length > 0) {
    for (var i = 0; i < priceSliders.length; i++) {
      noUiSlider.create(priceSliders[i], {
        start: [
          priceSliders[i].getAttribute("data-start"),
          priceSliders[i].getAttribute("data-end"),
        ],
        step: 50,
        range: {
          min: 0,
          max: 1000,
        },
        connect: true,
      });

      priceSliders[i].noUiSlider.on(
        "update",
        function (values, handle, unencoded, isTap, positions) {
          if (handle === 0) {
            document.querySelector(".price-start").innerHTML = parseInt(values[handle]);
          }
          if (handle === 1) {
            document.querySelector(".price-end").innerHTML = parseInt(
              values[handle]
            );
          }
        }
      );
    }
  }

  document.querySelector("#btn-price") &&
    document.querySelector("#btn-price").addEventListener("click", function () {
      const values = document.querySelector(".price-slider").noUiSlider.get();
      document.querySelector("#form-products input[name=price_start]").value =
        parseInt(values[0]);
      document.querySelector("#form-products input[name=price_end]").value =
        parseInt(values[1]);
      document.querySelector("#form-products").submit();
    });

  document.querySelector("[name=sort]") &&
    document
      .querySelector("[name=sort]")
      .addEventListener("change", function () {
        document.querySelector("#form-products [name=sort]").value = this.value;
        document.querySelector("#form-products").submit();
      });

  document.querySelector("#btn-toggle-filters") &&
    document
      .querySelector("#btn-toggle-filters")
      .addEventListener("click", function () {
        const filtersWrap = document.querySelector("#filters-wrap");
        const spanEl = document.querySelector("#btn-toggle-filters span");
        if (filtersWrap.offsetParent !== null) {
          filtersWrap.classList.add("hidden");
          spanEl.innerHTML = spanEl.getAttribute("data-on-text");
        } else {
          filtersWrap.classList.remove("hidden");
          spanEl.innerHTML = spanEl.getAttribute("data-off-text");
        }
      });
};